// @ts-nocheck
/* eslint-enable */
import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { zindex } from 'app/shared/styles/_zindex';
import { inline, stacked } from 'app/shared/styles/_spacing';
import ReactSlider from 'react-slider';
import FocusLockBase from 'react-focus-lock';

import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

// General
export const FocusLock = styled(FocusLockBase)`
  display: flex;
  width: 100%;
`;

export const InrixLogo = styled.img`
  padding-left: 8px;
`;
export const EditCommuteText = styled.label`
  ${font.sm};
  ${stacked._1x};
  font-weight: bold;
`;

export const CommuteAddressFlexContainer = styled.section`
  display: flex;
  width: 100%;
  ${stacked._2x};
`;

export const CommuteAddressLocationIconContainer = styled.span`
  ${inline._1x};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 32px;
  background-color: ${colors['$hpx-blue-500']};
  border-radius: 100%;
  flex: 0 0 32px;
`;

export const CommuteAddressLocationIcon = styled.img`
  position: relative;
`;

export const CommuteAddress = styled.p`
  line-height: 1.5;
`;

export const CommuteAddressEditButton = styled(Button)`
  ${font.md};
  color: ${colors['$hpx-teal-500']};
`;

export const DropdownFlexContainer = styled.section`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${stacked._2x};
`;

export const DropdownFlexSection = styled.section``;

export const DropdownLabel = styled.label`
  ${font.sm};
  ${stacked._1x};
  display: flex;
  align-items: center;
  color: ${colors['$hpx-grey-600']};
  font-weight: normal;
`;

export const DropdownLabelIcon = styled.img`
  ${inline._xs};
`;

export const DropdownButton = styled(Button)`
  display: block;
  width: 112px;
`;

export const DropdownList = styled.ul`
  width: 112px;
  margin-top: 4px;
  position: absolute;
  color: ${colors['$hpx-blue-600']};
  cursor: pointer;
  background-color: ${colors['$hpx-white']};
  border-radius: 4px;
  border: solid 1px ${colors['$hpx-grey-500']};
  z-index: ${zindex['$z-index-parent']};
`;

export const DropdownListItem = styled.li`
  ${font.sm};
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding: 8px 16px;
`;

// Slider
export const CommuteSlider = styled(ReactSlider)`
  ${stacked._6x};
  width: 100%;
  height: 25px;
`;

export const SliderThumb = styled.div`
  /* content: '||'; */
  cursor: grab;
  height: 30px;
  line-height: 30px;
  width: 30px;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 50%;
  box-shadow: 2px 2px 2px 0 rgb(0 0 0 / 15%);
  background: ${colors['$hpx-white']};
  color: ${colors['$hpx-grey-500']};
  font-size: 24px;
  letter-spacing: -1px;
  text-align: center;
  z-index: 3;
`;

export const SliderTrack = styled.div`
  top: 12px;
  bottom: 0;
  height: 6px;
  background: ${(props) => (props.index === 1 ? `${colors['$hpx-teal-500']}` : `${colors['$hpx-grey-500']}`)};
  border-radius: 999px;
`;

export const SliderMarks = styled.div`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  top: 30px;
`;

// Autocomplete
export const AutocompleteBarContainer = styled.div`
  display: flex;
  flex: 1;
  height: 32px;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  align-items: center;
  padding-left: 10px;
  padding-right: 16px;
  ${stacked._2x};
`;

export const InputIcon = styled.img`
  margin-right: 10px;
`;

export const Input = styled.input`
  min-width: calc(100% - 16px);
  height: 30px;
  border: none;
  color: ${colors['$hpx-blue-600']};
  padding: 8px;

  ::placeholder {
    ${font.sm};
    color: ${colors['$hpx-grey-600']};
  }

  &:after {
    content: '';
    display: block;
    margin: 0 auto;
    width: 100%;
    border-top: 1px solid ${colors['$hpx-grey-100']};
  }

  &:focus {
    outline: ${colors['$hpx-teal-600']} auto 1px;
    outline-offset: 3px;
  }
`;

export const MenuBox = styled.section`
  &:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 100%;
    border-top: 1px solid ${colors['$hpx-grey-100']};
  }

  position: absolute;
  width: 100%;
  height: 260px;
  background: white;
  border: 1px solid ${colors['$hpx-grey-500']};
  top: 83px;
  left: 0;
  border-radius: 4px;
  z-index: ${zindex['$z-index-step-over']};
  overflow-y: auto;
`;

export const SuggestionCategory = styled.li`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  padding-top: 16px;
  padding-left: 8px;
`;

export const Li = styled.li`
  /* display: flex;
    align-items: center; */
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding: 8px;

  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 3px;
  }
`;

export const SuggestionPrimaryText = styled.p`
  ${font.sm};
  font-weight: bold;
  color: ${colors['$hpx-blue-600']};
`;

export const SuggestionSecondaryText = styled.p`
  ${font.tiny};
  font-weight: normal;
  color: ${colors['$hpx-grey-600']};
`;

// Hidden from visual sight - used for screen readers
// @see https://adamsilver.io/articles/building-an-accessible-autocomplete-control/#using-a-live-region-to-make-sure-screen-reader-users-know-when-options-are-suggested
export const ScreenReaderOnly = styled.div`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
